module.exports = __webpack_public_path__ + "static/checkSectionbg-e6d93a53e0ed8c0d80addd9a72dc198b.png";